import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import type { ConsumerLocation } from '../geo/use-consumer-location';
import {
  parseDiscoveryFilters,
  readSessionFilters,
  serializeDiscoveryFilters,
  writeSessionFilters,
  type DiscoveryFilters,
} from './search-params';

export const RESULTS_PATH = '/home/busca';

/**
 * Cidade manual entra na URL (partilhável por ID); GPS/perfil nunca — só a cidade escolhida
 * explicitamente é "de quem partilha" (C2). O raio só existe com origem (schema da Edge).
 */
export function withLocationCity(filters: DiscoveryFilters, location: ConsumerLocation | null): DiscoveryFilters {
  const rest = { ...filters };
  delete rest.cityId;
  return location?.source === 'city' && location.city ? { ...rest, cityId: location.city.id } : rest;
}

/**
 * Estado dos filtros da descoberta = URL (C2). A sessão só completa campos ausentes, e cada
 * aplicação grava URL e sessão numa única transição — é o que faz Back/Forward reconstruírem a
 * tela a partir da URL sem estado paralelo.
 */
export function useDiscoveryFilters() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const filters = useMemo(() => parseDiscoveryFilters(search, readSessionFilters()), [search]);

  const apply = useCallback(
    (next: DiscoveryFilters, options: { replace?: boolean } = {}) => {
      writeSessionFilters(next);
      navigate({ pathname: RESULTS_PATH, search: `?${serializeDiscoveryFilters(next)}` }, { replace: options.replace });
    },
    [navigate],
  );

  return { filters, apply };
}
